// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__CrFR2","box":"ErrorPage_box__bHhHd","icon":"ErrorPage_icon__zlcNp","title":"ErrorPage_title__3dqro","message":"ErrorPage_message__JAr13"};